import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'

import './assets/style.css'

import VueClipboard from 'vue-clipboard2'
const VueUploadComponent = require('vue-upload-component')
 
Vue.component('file-upload', VueUploadComponent)

Vue.use(VueClipboard)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
